import React, { useCallback } from 'react';
import Title from '../../../components/common/title';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import Table from '../../../components/common/table/table';
import Barn from '../../../interfaces/barn';
import { useService } from '../../../services/services';
import css from './barn-list.module.css';
import { route } from '../../../services/utils';
import { LIVESTOCK_BARN_VIEW } from '../../../router/routes';
import { season } from '../../../store/global-slice';
import TabsKeys from '../../../enums/tab-keys';

export default function BarnList() {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const { barnService } = useService();

  const transKeyPrefix = 'pages.livestock.barn.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      barnService.index(farmId, { page, sort, desc, ...filter }),
    [barnService, farmId]
  );

  return (
    <div>
      <Title title={tp('title')} />
      <div>
        <Table<Barn>
          request={request}
          keyAccessor="id"
          columns={[
            {
              accessor: 'ldc_nr',
              header: tp('ldc_nr'),
              sortable: true,
              className: css['strong'],
            },
            {
              accessor: 'name',
              header: tp('name'),
              sortable: true,
            },
            {
              accessor: 'location',
              header: tp('location'),
              sortable: true,
            },
            {
              accessor: 'prohibitions',
              header: tp('prohibitions'),
            },
            {
              accessor: 'animal_count',
              header: tp('animal_count'),
            },
          ]}
          viewRoute={route(LIVESTOCK_BARN_VIEW, {
            farmId: farmId,
            tab: TabsKeys.basic_info,
            season: season,
          })}
          viewRecordAbility={{ title: 'view barn' }}
        />
      </div>
    </div>
  );
}
